import { WebsiteType, WebsiteStatus } from "../types/websites";

export interface WebsiteDeleteResponse {
  ok: boolean;
  success: boolean;
}

export interface Product {
  product_id: string;
  productId?: string;
  id?: string;
  type: string;
}

export interface WebsiteConfigurations {
  [key: string]: unknown;
  enabled: boolean;
  name_funnel: string;
  allowed_payment_methods?: string[];
  online_payment_provider?: string | null;
  checkout_provider?: string | null;
  shopify_checkout_enabled?: boolean | null;
}

// Interfaz principal que define la estructura de un sitio web
export interface Website {
  userId: string;
  projectId: string;
  websiteId: string;
  name: string;
  productName: string;
  type: WebsiteType;
  status: WebsiteStatus;
  url: string;
  publicUrl?: string | null;
  primaryPublicUrl?: string | null;
  primaryHost?: string | null;
  legacyOnlineslUrl?: string | null;
  candidateUrls?: string[];
  visits: number;
  conversionRate: number;
  salesSummary?: {
    salesCount: number;
    revenuePaid: number | string;
    currencyCode?: string | null;
    conversionRate?: number | string | null;
  } | null;
  theme: string;
  lastEdited: string;
  createdAt: string;
  sales_angle: string;
  sales_angle_description: string;
  sales_angle_complementary_angles?: string[];
  products: Product[];
  productImage?: string;
  generated?: boolean;
  hasErrors?: boolean;
  errorSections?: string[];
  generationStatus?: string | null;
  failureStage?: string | null;
  failureReason?: string | null;
  failureCode?: string | null;
  retryAvailable?: boolean;
  recoveryAction?: string | null;
  automaticOrderShopify?: boolean | null;
  automaticOrderDropi?: boolean | null;
  shopifyIntegrationStatus?: string | null;
  dropiIntegrationStatus?: string | null;
  configurations: WebsiteConfigurations;
  idSequence: number;
  brand_name: string;
}

// Interfaz para la URL de visualización
export interface UrlDisplay {
  full: string; // URL completa para el enlace
  short: string; // Versión corta para mostrar
}

// Interfaz para el estado del almacén de sitios web
export interface WebsitesState {
  projectId: string | null;
  userId: string | null;
  websites: Website[];
  tempChanges: Record<string, Partial<Website>>;
  hasChanges: boolean;
  isLoading: boolean;
  loadError: string | null;

  addWebsite: (
    website: Omit<Website, "id" | "createdAt" | "lastEdited">
  ) => void;
  deleteWebsite: (userId: string, id: string) => Promise<string>;
  setTempChanges: (changes: Record<string, Partial<Website>>) => void;

  initialize: () => Promise<void>; // used to get websites from project id
  projectActive: () => Promise<string>;
}

export interface SortConfig {
  key: keyof Website | null;
  direction: "asc" | "desc";
}

export enum ProductType {
  PRINCIPAL = "PRINCIPAL",
  UP_SELL = "UP_SELL",
  BUMP_OFFER = "BUMP_OFFER",
}
